<nav class="navbar navbar-expand navbar-dark bg-dark fixed-top">
 <!-- Updated brand: The brand now shows "All My Hugs" with the user image on its right if available -->
 <div class="d-flex align-items-center">
  <a class="navbar-brand ms-2" routerLink="/">Michael C. Kerr</a>
  <!-- Only show the dropdown if the user is authenticated -->
  <div *ngIf="isAuthenticated" class="dropdown ms-2">
    <a
      class="nav-link dropdown-toggle d-flex align-items-center"
      href="#"
      id="userDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <img
        *ngIf="userImagePath"
        [src]="userImageFullPath()"
        alt="User Image"
        class="user-image me-2"
      />
      <span class="navbar-brand ms-2" *ngIf="(userFirstname || userLastname)">
        {{ userFirstname }} {{ userLastname }}
      </span>
    </a>
    <ul class="dropdown-menu" aria-labelledby="userDropdown">
      <li>
        <a class="dropdown-item" routerLink="/dashboard">Dashboard</a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/myaccount">My Account</a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/myproducts">My Products</a>
      </li>
      <!-- Add more links as needed -->
    </ul>
  </div>
</div>

  <ul class="navbar-nav ms-auto me-2">
    

    
 



  

 

    <!--
    <li class="nav-item " *ngIf="isAuthenticated">
      <a routerLink="/Support" class="nav-link">Support</a>
    </li>
    --
    <li class="nav-item " *ngIf="isAuthenticated">
      <a *ngIf="role === 'admin'" routerLink="/dashboard" class="nav-link">My Account</a>
      <a *ngIf="role === 'user'" routerLink="/dashboard" class="nav-link">My Account</a>
      <a *ngIf="role === 'paiduser'" routerLink="/paid-dashboard" class="nav-link">My Account</a>
    </li>
  -->
  





    

  </ul>

  <li class="nav-item " *ngIf="isAuthenticated">
    <a *ngIf="role === 'admin'" routerLink="/dashboard" class="nav-link">Dashboard</a>
    <a *ngIf="role === 'user'" routerLink="/dashboard" class="nav-link">Dashboard</a>
    <a *ngIf="role === 'paiduser'" routerLink="/dashboard" class="nav-link">Dashboard</a>
  </li>

  <ul class="navbar-nav ms-auto me-2">
    <li class="nav-item " *ngIf="isAuthenticated && (roleService.role$ | async) === 'admin'">
      <a routerLink="/admin" class="nav-link">Admin</a>
    </li>
    <li class="nav-item " *ngIf="!isAuthenticated">
      <a routerLink="/login" class="nav-link">Login</a>
    </li>

    <li class="nav-item " *ngIf="isAuthenticated">
      <a (click)="onLogout()" class="nav-link" style="cursor: pointer;">Logout</a>
    </li>
  </ul>
</nav>
